import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app/app';
import './styles/index.scss';

window.addEventListener('orientationchange', () => {
  const orientation = window.matchMedia('(orientation: landscape)');

  if (orientation.matches) {
    window.location.reload();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'));
